import categoriesController from './categoriesController'

export default categoriesController



// WEBPACK FOOTER //
// ../src/controllers/categoriesController/index.js